import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

declare const module: any;

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.hmr) {
  if (module.hot) {
    hmrBootstrap(module, bootstrap);
  } else {
    // eslint-disable-next-line no-console
    console.error(
      'HMR is not enabled for webpack-dev-server! Are you using the --hmr flag for ng serve?'
    );
  }
} else {
  // eslint-disable-next-line no-console
  bootstrap().catch(err => console.error(err));
}
